module.exports = __webpack_public_path__ + "media/images/front/icon_m_twitter-052d2968f9287117206c7a4239b114c5.png";